import { Card, CardBody } from 'reactstrap';
import moment from 'moment';
import HistoricalChangeSet from './HistoricalChangeSet';

const HistoricalChangeCollection = (props) => {
    const {
        historicalChangeCollection,
        heading,
        propertiesToIgnore,
        renderOptions,
    } = props;

    if (!historicalChangeCollection) {
        return null;
    }

    const anyChanges = historicalChangeCollection
        && historicalChangeCollection.historicalChangeSets
        && historicalChangeCollection.historicalChangeSets.length > 0;

    // Sort all change sets by changeDate descending (latest on top)
    let sortedChangeSets = [];
    if (anyChanges) {
        sortedChangeSets = [...historicalChangeCollection.historicalChangeSets].sort(
            (a, b) => moment.utc(b.changeDate).valueOf()
                - moment.utc(a.changeDate).valueOf(),
        );
    }

    return (
        <>
            <h2 className="h6 fw-bold mb-2">{heading}</h2>

            {!anyChanges && (
                <Card className="border-0">
                    <CardBody className="text-muted">
                        No change history found.
                    </CardBody>
                </Card>
            )}

            {anyChanges && sortedChangeSets.map((hcs) => (
                <HistoricalChangeSet
                    key={`${hcs.entityId}|${hcs.changeDate}`}
                    historicalChangeSet={hcs}
                    propertiesToIgnore={propertiesToIgnore}
                    renderOptions={renderOptions}
                />
            ))}
        </>
    );
};

export default HistoricalChangeCollection;
